import 'focus-visible';

import React, { useCallback, useState } from 'react';
import { Header } from '~/components/header';
import { OverlayMenu } from '~/components/overlay_menu';
import './layout.css';

const Layout: React.FC = ({ children }) => {
  const [isOverlayMenuVisible, setIsOverlayMenuVisible] = useState(false);

  const handleHamburderMenuClick = useCallback(() => {
    setIsOverlayMenuVisible(true);
  }, []);

  const handleCloseButtonClick = useCallback(() => {
    setIsOverlayMenuVisible(false);
  }, []);

  return (
    <>
      <Header onHamburderMenuClick={handleHamburderMenuClick} />
      <main>{children}</main>
      <OverlayMenu
        isVisible={isOverlayMenuVisible}
        onCloseButtonClick={handleCloseButtonClick}
      />
    </>
  );
};

export default Layout;
